import CommunicationBlocks from "./communication-blocks";

export default CommunicationBlocks;